<template>
  <div id="app" class="app-container">
    <Header @toggle-language="toggleLanguage" :current-locale="locale" />
    <!-- 路由视图：根据URL切换首页/详情页 -->
    <router-view />
    <Footer :locale="locale" />
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'

export default {
  name: 'App',
  components: { Header, Footer },
  data() {
    return { locale: this.$i18n.locale }
  },
  created() {
    this.loadTheme()
  },
  methods: {
    toggleLanguage() {
      const newLocale = this.locale === 'zh' ? 'en' : 'zh'
      this.$i18n.locale = newLocale
      this.locale = newLocale
      localStorage.setItem('locale', newLocale)
    },
    async loadTheme() {
      const ThemeManager = (await import('./utils/theme')).default
      await ThemeManager.loadTheme()
    }
  },
  watch: {
    '$i18n.locale'(newLocale) { this.locale = newLocale }
  }
}
</script>

<style>
* { margin: 0; padding: 0; box-sizing: border-box; }
body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: var(--bg-primary, #ffffff);
  color: var(--text-primary, #1e293b);
  line-height: 1.6;
}
.app-container { min-height: 100vh; display: flex; flex-direction: column; }
.container { max-width: 1200px; margin: 0 auto; padding: 0 20px; }
.btn-primary {
  background: var(--primary-color, #1a56db);
  color: white; border: none; padding: 12px 28px; border-radius: 6px;
  font-size: 1rem; cursor: pointer; transition: all 0.2s ease; font-weight: 500;
}
.btn-primary:hover { background: var(--primary-dark, #1e40af); }
.btn-secondary {
  background: transparent; color: var(--text-primary, #1e293b);
  border: 1px solid var(--border-color, #e2e8f0);
  padding: 12px 28px; border-radius: 6px; font-size: 1rem; cursor: pointer;
  transition: all 0.2s ease; font-weight: 500;
}
.btn-secondary:hover { border-color: var(--primary-color, #1a56db); color: var(--primary-color, #1a56db); }
@media (max-width: 768px) {
  .container { padding: 0 15px; }
  .btn-primary, .btn-secondary { padding: 10px 20px; font-size: 0.9rem; }
}
</style>